import styled from '@emotion/styled'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import React, { useState } from 'react'

export const ButtonDropdown = styled.div`
  padding: 0 10px 0 16px;
  min-width: 140px;
  width: 150px;
  background-color: transparent;
  border-radius: 10px;
  border: 1px solid #707070;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 16%);
  cursor: pointer;
  height: 47px;
  &:hover {
    background-color: #e92c1f;
    color: #fff;
  }
  .arrow {
    font-size: 1em;
    margin-left: 10px;
    width: 12px;
    height: 12px;
  }
  .red {
    color: #e92c1f;
    background-color: rgba(233, 44, 31, 0.5);
    border-radius: 50%;
  }
  .green {
    color: #02bc77;
    background-color: rgba(2, 188, 119, 0.5);
    border-radius: 50%;
  }
`
export const DropdownStyle = styled.div`
  z-index: 10;
  border-radius: 10px;
  width: fit-content;
  border: 1px solid #707070;
  position: absolute;
  background-color: #f5f5f5;
`
export const DropdownItemStyle = styled.div`
  padding: 5px 30px;
  border-top: 1px solid #707070;
  min-width: 140px;
  width: 130px;
  text-align: center;
  cursor: pointer;
  line-height: 1.5;
  background-color: #f5f5f5;
  &:hover {
    background-color: #e92c1f;
    color: #fff;
  }
  &:nth-of-type(1) {
    animation: fadeInFromNone 0.1s ease-out;
    &:hover {
      border-radius: 10px 10px 0 0;
    }
  }
  &:nth-of-type(2) {
    animation: fadeInFromNone 0.2s ease-out;
  }
  &:nth-of-type(3) {
    animation: fadeInFromNone 0.3s ease-out;
  }
  &:nth-of-type(4) {
    animation: fadeInFromNone 0.4s ease-out;
  }
  &:nth-of-type(5) {
    animation: fadeInFromNone 0.5s ease-out;
  }
  &:nth-of-type(6) {
    animation: fadeInFromNone 0.6s ease-out;
  }
  &:nth-of-type(7) {
    animation: fadeInFromNone 0.7s ease-out;
  }
  &:nth-of-type(8) {
    animation: fadeInFromNone 0.8s ease-out;
  }
  &:last-child {
    &:hover {
      border-radius: 0 0 10px 10px;
    }
  }
  @-webkit-keyframes fadeInFromNone {
    0% {
      display: none;
      opacity: 0;
      border: none;
    }
    1% {
      display: block;
      opacity: 0;
    }
    100% {
      display: block;
      opacity: 1;
      border-top: 1px solid #707070;
    }
  }

  @-moz-keyframes fadeInFromNone {
    0% {
      display: none;
      opacity: 0;
    }
    1% {
      display: block;
      opacity: 0;
    }
    100% {
      display: block;
      opacity: 1;
    }
  }

  @-o-keyframes fadeInFromNone {
    0% {
      display: none;
      opacity: 0;
    }
    1% {
      display: block;
      opacity: 0;
    }
    100% {
      display: block;
      opacity: 1;
    }
  }

  @keyframes fadeInFromNone {
    0% {
      display: none;
      opacity: 0;
    }
    1% {
      display: block;
      opacity: 0;
    }
    100% {
      display: block;
      opacity: 1;
    }
  }
  &:first-of-type {
    border-top: none;
  }
`

export interface IDropDownProps {
  menuItems: string[]
  mapping: Record<string, string>
  defaultVal: number
  callBack: React.Dispatch<React.SetStateAction<string>>
}

export const DropDown: React.FC<IDropDownProps> = ({
  menuItems,
  mapping,
  defaultVal,
  callBack,
}) => {
  const [open, setOpen] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(defaultVal)

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const index = parseInt(e.currentTarget.id)
    setCurrentIndex(index)
    callBack(mapping[menuItems[index]])
    setOpen(false)
  }

  return (
    <div style={{ position: 'relative' }}>
      <ButtonDropdown onClick={() => setOpen(!open)}>
        <span> {menuItems[currentIndex]}</span>
        {open ? (
          <ArrowDropDownIcon className="arrow green" />
        ) : (
          <ArrowDropDownIcon className="arrow red" />
        )}
      </ButtonDropdown>
      {open ? (
        <DropdownStyle>
          {menuItems.map((item, i) => (
            <DropdownItemStyle
              onClick={handleClick}
              className={'DropDown'}
              id={i.toString()}
              key={i}
            >
              <span>{item}</span>
            </DropdownItemStyle>
          ))}
        </DropdownStyle>
      ) : null}
    </div>
  )
}

export interface ActionDropDownProps {
  actionItems: {
    name: string
    action: () => void
  }[]
}

export const ActionDropDown: React.FC<ActionDropDownProps> = ({
  actionItems,
}) => {
  const [open, setOpen] = useState(false)

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const index = parseInt(e.currentTarget.id)
    actionItems[index].action()
    setOpen(false)
  }

  return (
    <div>
      <ButtonDropdown onClick={() => setOpen(!open)}>
        <span> Export </span>
        {open ? (
          <ArrowDropDownIcon className="arrow green" />
        ) : (
          <ArrowDropDownIcon className="arrow red" />
        )}
      </ButtonDropdown>
      {open ? (
        <DropdownStyle>
          {actionItems.map((item, i) => (
            <DropdownItemStyle
              onClick={handleClick}
              className={'DropDown'}
              id={i.toString()}
              key={i}
            >
              <span>{item.name}</span>
            </DropdownItemStyle>
          ))}
        </DropdownStyle>
      ) : null}
    </div>
  )
}
